import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

export // Initialize Firebase
class Event
{
 
  subQueue=[];
  lastMessage=null;
  publish(args)
  {

    this.lastMessage=args;
    this.subQueue.forEach((cb)=>
    {
      cb(args);
    })
  }

  subscribe ( cb:Function )
  {
    this.subQueue.push(cb);
  }
  unsubscribe (cb:Function)
  {
     let ix= this.subQueue.findIndex( (e) =>{return (e==cb)});
     if (ix>=0)
     {
         this.subQueue.splice(ix, 1);
     }
  }
  flush()
  {
    this.subQueue=[];
  }
  constructor(public topic:string)
  {

  }
}
@Injectable({
    providedIn: 'root'
  })
  export class Events {

  queue=[];
  create(topic)
  {
    if (topic.length <1)
    return null;
if (this.queue.find((s)=>{return (s.topic==topic)}))
return null;
let event=new Event(topic);
this.queue.push(event);
return (event);
  }
  
  get(topic)
  {
    return (this.queue.find((s)=>{return (s.topic==topic)}))

  };
  

}

